/**
 * AutoGlow · Security Center API · Sprint T-15.
 *
 * Pure HTTP wrapper over the T-14 endpoints. NO business logic.
 * 1 endpoint = 1 method. Frontend NEVER duplicates backend authorization.
 */
import { api } from "../lib/api";

// ---------------------------------------------------------------------------
// 2FA · /api/auth/2fa/*
// ---------------------------------------------------------------------------

export const twoFactorApi = {
  status: () => api.get(`/auth/2fa/status`),
  enable: () => api.post(`/auth/2fa/enable`),
  enableVerify: (code) => api.post(`/auth/2fa/enable/verify`, { code }),
  verify: (code) => api.post(`/auth/2fa/verify`, { code }),
  disable: (code) => api.post(`/auth/2fa/disable`, { code }),
  regenerateBackup: (code) =>
    api.post(`/auth/2fa/backup-codes/regenerate`, { code }),
};

// ---------------------------------------------------------------------------
// API Keys · /api/security/api-keys/*
// ---------------------------------------------------------------------------

export const apiKeysApi = {
  scopes: () => api.get(`/security/api-keys/scopes`),
  list: () => api.get(`/security/api-keys/`),
  create: ({ name, scopes, description, expires_at }) =>
    api.post(`/security/api-keys/`, { name, scopes, description, expires_at }),
  revoke: (id) => api.post(`/security/api-keys/${encodeURIComponent(id)}/revoke`),
  rotate: (id) => api.post(`/security/api-keys/${encodeURIComponent(id)}/rotate`),
  get: (id) => api.get(`/security/api-keys/${encodeURIComponent(id)}`),
};

// ---------------------------------------------------------------------------
// Compliance / GDPR · /api/security/compliance/*
// ---------------------------------------------------------------------------

export const complianceApi = {
  policies: () => api.get(`/security/compliance/policies`),
  exportMe: () => api.get(`/security/compliance/export/me`),
  exportOther: ({ user_id, customer_id, email } = {}) =>
    api.get(`/security/compliance/export`, {
      params: { user_id, customer_id, email },
    }),
  deleteMe: () => api.delete(`/security/compliance/me`),
  deleteUser: (user_id, mode = "soft") =>
    api.delete(`/security/compliance/user/${encodeURIComponent(user_id)}`, {
      params: { mode },
    }),
  deleteCustomer: (customer_id, mode = "soft") =>
    api.delete(`/security/compliance/customer/${encodeURIComponent(customer_id)}`, {
      params: { mode },
    }),
};

// ---------------------------------------------------------------------------
// Audit events · /api/superadmin/audit-events (existente · S-4)
// ---------------------------------------------------------------------------

export const auditApi = {
  list: ({ limit = 50, offset = 0, action, actor_email, organization_id, only_failures } = {}) =>
    api.get(`/superadmin/audit-events`, {
      params: { limit, offset, action, actor_email, organization_id, only_failures },
    }),
};

// Aggregate
export const securityApi = {
  twofa: twoFactorApi,
  apiKeys: apiKeysApi,
  compliance: complianceApi,
  audit: auditApi,
};

export default securityApi;
